export const REDUCER_KEY = 'adslots';
